import {
  Path,
  Node
} from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { toggleBlock } from '../../3rd-party/rich-text';
import types from '../../elements/types';
import HelptapEditor from '../';
import * as headerDuplication from './site-nav/settings';
import * as layoutDuplication from './layout/duplicate';
import * as iconDuplication from './icon/clone';

export function duplicateNode(editor, node, nodePath) {
  if (node.type === 'site-nav') {
    headerDuplication.duplicate(editor, node, nodePath);
    return;
  }

  const nodeType = node.type;
  const duplicateNodePath = Path.next(nodePath);

  if (nodeType === types.LAYOUT || Node.get(editor, Path.parent(nodePath)).type === types.LAYOUT) {
    layoutDuplication.duplicate(editor, node, duplicateNodePath);
    return;
  }

  if (nodeType === types.ICON) {
    iconDuplication.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.DEFAULT) {
    HelptapEditor.paragraph.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.FORM) {
    HelptapEditor.form.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.BUTTON) {
    HelptapEditor.button.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_ONE) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_TWO) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_THREE) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_FOUR) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_FIVE) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HEADING_SIX) {
    HelptapEditor.heading.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.HT_FILE) {
    HelptapEditor.file.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.BULLETED_LIST) {
    HelptapEditor.list.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.NUMBERED_LIST) {
    HelptapEditor.list.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.CHECK_LIST) {
    HelptapEditor.list.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.URL_EMBED) {
    HelptapEditor.urlEmbed.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.SOURCE_CODE_REGION) {
    HelptapEditor.sourceCodeRegion.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.BLOCK_QUOTE) {
    HelptapEditor.blockQuote.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.DIVIDER) {
    HelptapEditor.divider.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.MULTIPLE_COLUMNS) {
    HelptapEditor.multipleColumns.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.TABLE_OF_CONTENTS) {
    HelptapEditor.tableOfContents.duplicate(editor, node, duplicateNodePath);
  } else if (nodeType === types.TABLE) {
    HelptapEditor.table.duplicate(editor, node, duplicateNodePath);
  } else {
    throw new Error('Duplication is not possible for this node yet!');
  }

};

export function cloneNode(node) {
  if (['site-nav', 'site-nav-region', 'site-nav-item'].includes(node.type)) {
    return serializer.utilities.node.siteNav.cloneNode(node, cloneNode);
  }

  const nodeType = node.type;

  if (nodeType === types.LAYOUT) {
    return layoutDuplication.cloneNode(node);
  } else if (nodeType === types.ICON) {
    return serializer.utilities.node.icon.cloneNode(node);
  } else if (nodeType === types.FORM) {
    return HelptapEditor.form.cloneNode(node);
  } else if (nodeType === types.BUTTON) {
    return HelptapEditor.button.cloneNode(node);
  } else if (nodeType === types.AUTHENTICATOR_BUTTON) {
    return HelptapEditor.authenticatorButton.cloneNode(node);
  } else if (nodeType === types.HT_FILE) {
    return HelptapEditor.file.cloneNode(node);
  } else if (nodeType === types.MULTIPLE_COLUMNS) {
    return HelptapEditor.multipleColumns.cloneNode(node);
  } else {
    return HelptapEditor.cloneNode(node);
  }

};

export function cloneNodes(nodes) {

  const clonedNodes = [];

  for (let node of nodes) {
    clonedNodes.push(cloneNode(node));
  }

  return clonedNodes;

};

export function toggle(editor, properties) {

  toggleBlock(editor, types.FAVOURITE_PAGE_NODE_CLONER, serializer.utilities.favouritePageNodes.createFavouritePageNodeCloner(properties.favouritePageNode, properties.pageId));

}
